import { useRef } from "react";


interface LgRefImageInputProps {
    previewImg?: any | null; 
    setPreview?: {
        setValue: (action:string, key:string, value: any) => void;
        action : string;
        key: string;
    }
    name: string;
    disabled: boolean;

}


export const LgRefImageInput = ({ previewImg=null, ...props }: LgRefImageInputProps) => {
    
    const handleImageChange = () => {
        const file = fileInputRef.current.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (props.setPreview?.setValue) {
                    props.setPreview.setValue(props.setPreview.action, props.setPreview.key, reader.result)
                }
            };
            reader.readAsDataURL(file);
        }
      };

    const handleImageClick = () => {
        // Trigger file input click
        fileInputRef.current?.click();
    };


    const fileInputRef = useRef<any>(null);

    return (
        <div style={{
            width: '47px',
            height: '47px',
            content: "",
            borderRadius: "100%",
            flexShrink: "0",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
        }} className="bg-gray standard-border relative">
            <div className={`circle absolute bg-secondary ${!props.disabled ? 'add-img-icon-btn' : 'add-img-icon-btn-dsbl' }`} onClick={handleImageClick} style={{scale:"0.8"}}>
                <div className="plus"></div>
            </div>
            <input
                disabled={props.disabled}
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: "none" }}
                ref={fileInputRef}
                id={props.name}
                name={props.name}
            />
            {(previewImg !== null) && (
                    <img className="" src={previewImg} alt="" />
            )}
            { previewImg===null && (
                <svg width="40" height="40" viewBox="0 0 58 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M14.8195 15.3759C14.8195 11.5237 17.9488 8.39453 21.8175 8.39453H48.6968V9.78584H21.8175C18.7243 9.78584 16.217 12.2884 16.217 15.3759H14.8195Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M12.9952 14.6797H18.3398L18.6496 34.0781H12.3755L12.9952 14.6797ZM14.3491 16.071L13.8182 32.6868H17.2297L16.9642 16.071H14.3491Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M17.6519 22.612H13.6721V21.2207H17.6519V22.612Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M17.6519 26.5026H13.6721V25.1113H17.6519V26.5026Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M17.6519 30.3981H13.6721V29.0068H17.6519V30.3981Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M21.2263 18.3135H26.5588L26.8743 34.0785H20.5913L21.2263 18.3135ZM22.569 19.7048L22.0461 32.6872H25.4486L25.1888 19.7048H22.569Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M25.8738 26.5026H21.8976V25.1113H25.8738V26.5026Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M25.8738 30.3981H21.8976V29.0068H25.8738V30.3981Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.65259 33.0684H49.3956V47.6089H9.65259V33.0684ZM11.0502 34.4597V46.2176H47.998V34.4597H11.0502Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M45.9514 39.194H28.6921V37.8027H45.9514V39.194Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M45.9514 42.8786H28.6921V41.4873H45.9514V42.8786Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M14.9651 37.8574H25.9099V47.6055H14.9651V37.8574ZM16.3627 39.2487V46.2142H24.5123V39.2487H16.3627Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M38.3416 23.6836H49.3992V34.4563H38.3416V23.6836ZM39.7391 25.0749V33.065H48.0016V25.0749H39.7391Z" fill="#A8A8A8"/>
                </svg> 
            )}               
        </div>
    )
}


interface ImageInputProps extends LgRefImageInputProps {
    size?: 'sm' | 'base' | 'lg'
    defaultImg?: 'profile' | 'building'
}


export const ImageInput = ({ previewImg=null, size="sm", defaultImg='building', ...props }: ImageInputProps) => {
    const setSize = (value: ImageInputProps['size']): string => {
        switch (value) {
            case 'sm' : 
                return '47px';
            case 'base': 
                return '70px';
            case 'lg':
                return '90px';
            default:
                throw new Error("Must be one of 'sm' | 'base' | 'lg'")
        }
    }

    const icon = (value: ImageInputProps['defaultImg']) => {
        switch (value) {
            case 'profile' : return (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 19L20 20M12 14C14.7614 14 17 11.7614 17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14ZM12 14C7.58172 14 4 16.6863 4 20M19 17C19 18.1046 18.1046 19 17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17Z" stroke='#111111' strokeWidth="2" strokeLinecap="round"/>
                </svg>
            );
            case 'building' : return (
                <svg width="40" height="40" viewBox="0 0 58 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M14.8195 15.3759C14.8195 11.5237 17.9488 8.39453 21.8175 8.39453H48.6968V9.78584H21.8175C18.7243 9.78584 16.217 12.2884 16.217 15.3759H14.8195Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M12.9952 14.6797H18.3398L18.6496 34.0781H12.3755L12.9952 14.6797ZM14.3491 16.071L13.8182 32.6868H17.2297L16.9642 16.071H14.3491Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M17.6519 22.612H13.6721V21.2207H17.6519V22.612Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M17.6519 26.5026H13.6721V25.1113H17.6519V26.5026Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M17.6519 30.3981H13.6721V29.0068H17.6519V30.3981Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M21.2263 18.3135H26.5588L26.8743 34.0785H20.5913L21.2263 18.3135ZM22.569 19.7048L22.0461 32.6872H25.4486L25.1888 19.7048H22.569Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M25.8738 26.5026H21.8976V25.1113H25.8738V26.5026Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M25.8738 30.3981H21.8976V29.0068H25.8738V30.3981Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.65259 33.0684H49.3956V47.6089H9.65259V33.0684ZM11.0502 34.4597V46.2176H47.998V34.4597H11.0502Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M45.9514 39.194H28.6921V37.8027H45.9514V39.194Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M45.9514 42.8786H28.6921V41.4873H45.9514V42.8786Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M14.9651 37.8574H25.9099V47.6055H14.9651V37.8574ZM16.3627 39.2487V46.2142H24.5123V39.2487H16.3627Z" fill="#A8A8A8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M38.3416 23.6836H49.3992V34.4563H38.3416V23.6836ZM39.7391 25.0749V33.065H48.0016V25.0749H39.7391Z" fill="#A8A8A8"/>
                </svg> 
            );
            default:
                throw new Error("Must be one of 'profile' | 'building'")
        }
    }
    
    const handleImageChange = () => {
        const file = fileInputRef.current.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (props.setPreview?.setValue) {
                    props.setPreview.setValue(props.setPreview.action, props.setPreview.key, reader.result)
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const handleImageClick = () => {
        // Trigger file input click
        fileInputRef.current?.click();
    };


    const fileInputRef = useRef<any>(null);

    return (
        <div style={{
            width: setSize(size),
            height: setSize(size),
            content: "",
            borderRadius: "100%",
            flexShrink: "0",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
        }} className="bg-gray standard-border relative">
            <div className="circle absolute bg-secondary add-img-icon-btn" onClick={handleImageClick} style={{scale:"0.8"}}>
                <div className="plus"></div>
            </div>
            <input
                disabled={props.disabled}
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: "none" }}
                ref={fileInputRef}
                id={props.name}
                name={props.name}
            />
            {(previewImg !== null) && (
                    <img className="" src={previewImg} alt="" />
            )}
            { previewImg===null && ( icon(defaultImg) )}               
        </div>
    )
}